<template>
  <div class="flex flex-col gap-2 p-0 h-full">

    <div class="grid grid-cols-1 lg:grid-cols-12 gap-2 bg-[var(--fundoForm)] rounded-[10px] p-2 flex-1 min-h-0">

      <div class="lg:col-span-3 overflow-y-auto scrollbar-tema">
        <FiltrosPesquisa @confirm="set_filtro" ref="ref_filtros"/>
      </div>

      <div class="lg:col-span-4 overflow-hidden">
        <CartoesServicos ref="cartoesRef" @confirm="refresacarFiltros" @refresh-data="refreshCartoesData" @refreshCalendario="refrescarCalendario" :dados_filtros="filtros_dados"/>
      </div>

      <div class="lg:col-span-5 overflow-y-auto scrollbar-tema">
        <AppWeelkyCalendar ref="refrescar" @confirm="refresacarFiltros" />
      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import { id as loggedID } from "@/extraData";
import CartoesServicos from "./componentes/CartoesServicos.vue";
import FiltrosPesquisa from "./componentes/FltrosPesquisa.vue";
import AppWeelkyCalendar from "@/components/calendario/semanaCalendarioNovo.vue";

export default {
  name: "appPlaneamentoView2",
  components: {
    FiltrosPesquisa,
    CartoesServicos,
    AppWeelkyCalendar,
  },
  data() {
    return {
      filtros_dados: {},
      baseURl: process.env.VUE_APP_URL_BASE,
      loggedID: loggedID,
      user: { id: 0, nome: "", tipo: { nome: "" } },
    };
  },
 
  methods: {
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    refrescarCalendario() {
      this.$refs.refrescar.getPlaneamento();
    },
    refreshCartoesData() {
      this.$refs.cartoesRef.refresh();
    },
    refresacarFiltros() {
      this.$refs.ref_filtros.salvar_filtro();
    },

    async set_filtro(data) {
      console.log("Filtro:", data);
      this.filtros_dados = { ...data };
    },
  },
};
</script>

<style>
/* Permitir scroll natural */
html, body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

#app {
  min-height: 100vh;
}

/* Scroll customizado */
.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}

.scrollbar-tema::-webkit-scrollbar {
  width: 8px;
}

.scrollbar-tema::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.scrollbar-tema::-webkit-scrollbar-thumb {
  background: var(--scroll, #888);
  border-radius: 4px;
}

.scrollbar-tema::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-hover, #555);
}
</style>
